import React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import 'react-toastify/dist/ReactToastify.css';

import useOrder from '../../../context/OrderContext';

const QuoteNotification = () => {
    const { isShowQuotePopup, setIsShowQuotePopup, pickInfo, dropInfo, accountInfo, resetOrderTelFormValues } = useOrder();
    const { register, getValues, handleSubmit, watch } = useForm({
        defaultValues: {
            headAccount: accountInfo?.emailAddress,
            consignor: pickInfo?.emailAddress,
            consignee: dropInfo?.emailAddress,
        } || {},
    })
    const { headAccount, consignor, consignee } = getValues();
    const onClose = () => {
        resetOrderTelFormValues()
        setIsShowQuotePopup(false)
    }
    const SubmitHandler = handleSubmit(async (formData) => {
        onClose();
    });


    return (
        <>
            <Modal show={isShowQuotePopup} onHide={onClose} size="md" centered>
                <Modal.Header closeButton>
                    Email Notification
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col sm={12} className='mb-3'>
                            <div className="email-notify h-100">
                                <div className="email-heading">
                                    <h6>Quote</h6>
                                </div>
                                <div className="p-3 pb-0" >
                                    <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" label="Send to head account" name="headAccount"  {...register('headAccount')} checked={watch("headAccount")} />
                                        {headAccount ? <label htmlFor="element" style={{ marginLeft: "26px", fontWeight: "500" }}>({accountInfo?.emailAddress})</label> : null}
                                    </Form.Group>
                                    <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" label="Send to consignor (Shipper)" name="consignor" {...register('consignor')} checked={watch("consignor")} />
                                        {consignor ? <label htmlFor="element" style={{ marginLeft: "26px", fontWeight: "500" }}>({pickInfo?.emailAddress})</label> : ""}
                                    </Form.Group>
                                    <Form.Group controlId="formBasicCheckbox">
                                        <Form.Check type="checkbox" label="Send to consignee (Receiver)" name="consignee" {...register('consignee')} checked={watch("consignee")} />
                                        {consignee ? <label htmlFor="element" style={{ marginLeft: "26px", fontWeight: "500" }}>({dropInfo?.emailAddress})</label> : ""}
                                    </Form.Group>
                                </div>
                            </div>
                        </Col>
                        <div className='mb-3'>
                            <Form.Control as="textarea" placeholder="Description" {...register('description')} style={{ height: '100px' }} />
                        </div>
                    </Row>
                    <Row className="justify-content-end">
                        <Col sm={3} >
                            <Button variant="primary" className={"save-btn"} onClick={SubmitHandler}>Submit</Button>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal >
        </>

    );
}

export default QuoteNotification;